// JK Estates site data - all images are user-uploaded (no stock).

export const siteData = {
  brand: {
    name: "JK Estates",
    tagline: "TURNING DREAMS INTO ADDRESS",
    logo: "/img/logo.jpg",
    phones: ["96531-11222", "98140-39143"],
    primaryPhone: "96531-11222",
    primaryPhoneRaw: "9653111222",
    altPhone: "98140-39143",
    altPhoneRaw: "9814039143",
    whatsapp: "919653111222",
    email: "hello@jkestates.in",
    address: "#2106, Sector 82A, IT City, Mohali",
    coverage: "Chandigarh \u00b7 Mohali \u00b7 Panchkula (Tricity)",
    hours: "Mon \u2013 Sat \u00b7 10 AM \u2013 7 PM",
    trust: "Serving since 2009 \u2022 200+ satisfied customers across Tricity",
  },

  pillars: [
    { title: "Trusted Local Dealer", desc: "Over a decade of deep expertise across Chandigarh, Mohali and Panchkula \u2014 we know every sector, every project, every builder.", icon: "Handshake" },
    { title: "Verified Properties", desc: "Every listing is legally vetted, RERA-checked where applicable, and physically inspected before we present it to you.", icon: "ShieldCheck" },
    { title: "End-to-End Support", desc: "From first site visit to registry and possession \u2014 documentation, loans, legal checks, interiors \u2014 all handled under one roof.", icon: "CheckCircle2" },
  ],

  stand: [
    { title: "Integrity First", desc: "Clear paperwork, clear intentions. What we promise is what we deliver.", icon: "Gem" },
    { title: "Relationship Driven", desc: "Most of our business comes from referrals \u2014 that's the scoreboard we trust.", icon: "Users" },
    { title: "Hyper-Local", desc: "We operate only in Tricity. Depth over breadth, always.", icon: "MapPin" },
  ],

  coverage: [
    { city: "Chandigarh", tag: "ACTIVE COVERAGE" },
    { city: "Mohali", tag: "ACTIVE COVERAGE" },
    { city: "Panchkula", tag: "ACTIVE COVERAGE" },
  ],

  services: [
    { num: "01", kicker: "RESIDENTIAL", title: "Residential Deals",
      desc: "Plots, independent kothis, builder floors and premium flats across the Tricity. Family-first, future-ready.",
      points: ["Ready-to-move villas & kothis", "New-launch apartments with payment plans", "Premium plots in approved sectors", "Resale with verified titles & NOCs"],
      image: "/img/hero-villa.jpg" },
    { num: "02", kicker: "COMMERCIAL", title: "Commercial Deals",
      desc: "SCOs, showrooms, office spaces and retail units in high-footfall, high-visibility locations across the Tricity.",
      points: ["SCOs & showrooms in prime sectors", "Grade-A office spaces & co-working", "High-street retail with parking", "Pre-leased commercial investments"],
      image: "/img/gillco-commercial.jpg" },
    { num: "03", kicker: "INDUSTRIAL", title: "Industrial Deals",
      desc: "Industrial plots, warehouses and manufacturing units in established zones with clear titles and approvals.",
      points: ["Industrial plots in IT City & Phase 8", "Pre-built warehouses with loading docks", "Manufacturing units with power backup", "Land aggregation for larger setups"],
      image: "/img/industrial-poster.jpg" },
  ],

  properties: [
    { id: "P-01", category: "Residential", featured: true,
      title: "Super Luxury Cottages in Kasauli", location: "Kasauli, Himachal Pradesh",
      tag: "Premium Luxury Cottage",
      desc: "Premium luxury cottages available for sale in Kasauli with scenic mountain views, modern amenities and world-class architecture. Ideal as a weekend retreat, second home or boutique investment.",
      price: "Price on Request", images: ["/img/hero-villa.jpg"] },
    { id: "P-02", category: "Industrial", featured: true, exclusive: true,
      title: "250 Bigha Industrial Land on Banur Tepla Road", location: "Banur Tepla Road, Punjab",
      tag: "250 Bigha \u00b7 CLU Done",
      desc: "Exclusive sale rights with JK Estates \u2014 250 Bigha industrial land with CLU approved and company transfer ready. Prime connectivity on Banur Tepla Road, suitable for large-scale manufacturing or logistics.",
      price: "Price on Request", images: ["/img/industrial-poster.jpg"] },
    { id: "P-03", category: "Residential", featured: true,
      title: "Upcoming Super Luxury Flats", location: "Sector 88, Mohali",
      tag: "Upcoming Launch",
      desc: "Upcoming Super Luxury Flats in Sector 88, Mohali.",
      price: "Price on Request", images: ["/img/prop3-a.jpg", "/img/prop3-b.jpg"] },
    { id: "P-04", category: "Residential",
      title: "Upcoming Super Luxury Flats", location: "Sector 78, Mohali",
      tag: "Upcoming Launch",
      desc: "Upcoming Super Luxury Flats in Sector 78, Mohali.",
      price: "Price on Request", images: ["/img/prop4.jpg"] },
    { id: "P-05", category: "Commercial",
      title: "20/80 Showrooms for Sale", location: "Gillco Industrial Park, Mohali",
      tag: "Main Airport Road Frontage",
      desc: "20/80 size showroom site facing 200 ft Airport Road, located in Gillco Industrial Park, Mohali.",
      price: "Price on Request", images: ["/img/gillco-commercial.jpg"] },
  ],

  // Gallery: video-extracted on-ground & office shots (uploaded via the original video).
  gallery: [
    { src: "/img/gallery-1.jpg", alt: "Inside the JK Estates Mohali office" },
    { src: "/img/gallery-2.jpg", alt: "JK Estates \u2014 Turning Dreams into Address" },
    { src: "/img/gallery-3.jpg", alt: "Outside the JK Estates office" },
    { src: "/img/gallery-4.jpg", alt: "JK Estates on-ground" },
  ],

  // About page exclusive images (user-uploaded, do not reuse elsewhere).
  aboutImages: [
    { src: "/img/about-office.jpg", alt: "Inside the JK Estates office \u2014 Mohali" },
    { src: "/img/about-exterior.jpg", alt: "JK Estates headquarters exterior \u2014 Sector 82A, Mohali" },
  ],

  hero: {
    image: "/img/hero-villa.jpg",
    kicker: "SINCE 2009 \u00b7 TRICITY'S TRUSTED REAL ESTATE",
    title1: "Find Premium Properties in",
    titleAccent: "Chandigarh, Mohali & Panchkula",
    sub: "Residential \u00b7 Commercial \u00b7 Industrial Deals",
    footer: "Serving since 2009 \u2022 200+ satisfied customers across Tricity",
  },

  aboutStory: {
    kicker: "OUR STORY",
    title: "Born in Mohali, built on trust.",
    body: [
      "JK Estates has been serving the Tricity since 2009 with a single, simple belief \u2014 that buying or selling property shouldn't feel like navigating a minefield. Back then, the Mohali skyline was just starting to take shape. Today, our roots run through every major sector and we've served 200+ satisfied customers across Chandigarh, Mohali and Panchkula.",
      "We're not a call-center. We're a small, senior team of property consultants who personally visit every listing, personally handle every negotiation, and personally stand behind every handover.",
    ],
  },
};
